module.exports = __webpack_public_path__ + "img/bg1.ac40f8a4.jpg";